import { useSelector } from 'react-redux';

export default function useCurrentSiteId() {
  const currentSiteId = useSelector((state:any) => state.site.currentSiteId);
  return currentSiteId;
}
